import { NgModule } from '@angular/core';

import { DeviceStatusPipe } from './device-status-pipe';

@NgModule({
  declarations: [DeviceStatusPipe],
  exports: [DeviceStatusPipe],
})
export class DeviceStatusPipeModule {}
